import React, { FC, useContext } from 'react'
import { GuestContext } from '../Guest.context'
import FullScreenLoader from '@components/FullScreenLoader/FullScreenLoader.component'
import { Success } from './Success.view'
import { EmailNotSent } from './EmailNotSent.view'
import { Error } from './Error.view'

export const GuestFinal: FC = () => {
    const { loading, applyWhitelistResult } = useContext(GuestContext)

    if (loading) {
        return <FullScreenLoader />
    }

    if (applyWhitelistResult === 'SUCCESS') {
        return <Success />
    }
    if (applyWhitelistResult === 'EMAIL_NOT_SENT') {
        return <EmailNotSent />
    }
    return <Error />
}
